import Navbar from "../components/Navbar";
import heroPic from '../images/heroIMG.png'
import reactImg from '../images/react1.png'
import Footer from "../components/Footer";

const Home = () => {
  let code = 'Dev Way'
 

  
  
  return (
        <div>
           <Navbar/>
       <header>
          <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="textBox">
                        <div class="dynamic-text">
                            <span >front-end developer</span>
                        </div>
                        
                    </div>
                    <h1>Bringing Designs To Life the {code}</h1>
                    <p>Building momentum by building better websites</p>
                    <a href="mailto:craigtogs@gmail.com"><button class="open-button">Contact Me!</button></a>
  
                 </div>
                 <div class="col-lg-7">
                  <div className="heroPic">
                      <img src={heroPic} alt="" className="img-fluid"/>
                  </div>
                  <div className="reactIMG">
                      <img src={reactImg} alt="reactIMG" className="reactImg"/>
                  </div>
                  
                 
                 </div>

            </div>
             

          </div>
           
    </header>
    <Footer/>

        </div>
   
  );
};
export default Home;
